<template>
    <div class="grid">
        <div class="unit whole">
            <h1>Reporting</h1>
            <p class="lead">View task results and usage.</p>
        </div>
    </div>
    <div class="grid">
        <div class="unit whole">
            <div class="grid">
                <div class="unit half">
                    <div class="panel">
                        <h2>Overview</h2>
                        <p>View reading test question results over time at class or pupil level.</p>
                        <RouterLink class="btn" to="/admin/reporting-overview">View overview</RouterLink>
                    </div>
                </div>
                <div class="unit half">
                    <div class="panel">
                        <h2>Combined results</h2>
                        <p>View pupil reading test question results combined and over time.</p>
                        <RouterLink class="btn" to="/admin/reporting-combined-results"
                            >View combined results</RouterLink
                        >
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="unit half">
                    <div class="panel">
                        <h2>Usage</h2>
                        <p>View overall usage for your pupils.</p>
                        <RouterLink class="btn" to="/admin/reporting-usage">View usage</RouterLink>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
definePage({ meta: { area: 'reporting' } });
</script>
